import * as React from "react";
import * as S from "@styled";

import { EditorProps } from "./EnvironmentVariableEditor";
import { StringEditor } from "./StringEditor";

export class ArrayEditor extends React.PureComponent<React.PropsWithChildren<EditorProps<string[]>>, {}> {
    public render() {
        const values = this.props.value || [];
        return (
            <div className="array-editor">
                {this.props.children}
                {values.map((value, index) => {
                    return <div key={index} style={{ marginBottom: '16px' }}>
                        <StringEditor
                            environmentId={this.props.environmentId}
                            value={value}
                            updateSingleValue={(value) => this.itemChanged(value, index)}
                        >
                            <S.Button type="button" className="delete-array-item" onClick={() => this.removeItemClicked(index)} style={{ marginLeft: '8px' }}>
                                <i className="ci-trash_full" />
                            </S.Button>
                        </StringEditor>
                    </div>;
                })}
                <div className="arrayCommands" style={{ marginTop: '8px' }}>
                    <S.Button type="button" className="add-item-selector" name="add" onClick={this.addItemClicked}><i className="ci-plus" /> {FRENDS.Localizations.Add}</S.Button>
                </div>
            </div>
        );
    }

    private addItemClicked = () => {
        const copy = this.getCopyOrNewArray();
        copy.push("");
        this.props.updateSingleValue(copy, this.props.environmentId);
    }

    private removeItemClicked = (index: number) => {
        const copy = this.getCopyOrNewArray();
        copy.splice(index, 1);
        this.props.updateSingleValue(copy, this.props.environmentId);
    }

    private getCopyOrNewArray() {
        let copy: any[];
        if (this.props.value == null) {
            copy = [];
        } else {
            copy = this.props.value.slice();
        }
        return copy;
    }

    private itemChanged(value: string, index: number) {
        const copy = this.getCopyOrNewArray();
        copy[index] = value;
        this.props.updateSingleValue(copy, this.props.environmentId);
    }
}
